import { baseTemplateParams } from '../shared/baseParams.js'
import { SILVERADO_RESORT_DEFAULTS } from '../shared/resortDiscoveryDefaults.js'

export const defaultTemplateParams = {
  ...baseTemplateParams,
  ...SILVERADO_RESORT_DEFAULTS,
  richtextFields: {
    ...baseTemplateParams.richtextFields,
    ...SILVERADO_RESORT_DEFAULTS.richtextFields
  },
  selectedTemplate: 'resortDiscovery',
  shellTemplateKey: 'resortDiscovery'
}

export default defaultTemplateParams
